import { SlugNameService } from '../../Services/slug-name.service';
import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { EmbryoService } from "../../Services/Embryo.service";
import { Router } from "@angular/router";
import { LoginUsersService } from "../../Services/login-users.service";
import { CheckoutService } from "../../Services/checkout.service";
import { HomePageService } from "../../Services/home-page.service";
import { Subscription } from "rxjs";
import { ReactivityService } from "../../Services/reactivity.service";
import { StaticPagesService } from "src/app/Services/static-pages.service";
import Swal from "sweetalert2";

@Component({
    selector: "app-compare-list-menu",
    templateUrl: "./compare-list-menu.component.html",
    styleUrls: ["./compare-list-menu.component.scss"],
})
export class CompareListMenuComponent implements OnInit {
    @Input() lang: any;
    @ViewChild("menuTrigger", { static: false }) menuTrigger: any;
    currency = this.embryoService.currency;
    compareListProducts: Array<any> = [];
    clonedProducts: Array<any> = [];
    isAuthUser: any;
    user: any;
    enteredMenu: boolean = false;
    subscription: Subscription;
    isMobile: any;
    environmentVariables: any;
    headerIconsColor:any
     changeIconFill:boolean = true;
    constructor(
        private embryoService: EmbryoService,
        private userLoginService: LoginUsersService,
        private checkoutService: CheckoutService,
        private homePageService: HomePageService,
        private reactivityService: ReactivityService,
        private router: Router,
        private confgServ: StaticPagesService,
				private slugNameService:SlugNameService,
    ) {
        this.subscription = this.reactivityService.storeObserver$.subscribe(
            (data: any) => {
                this.isAuthUser = JSON.parse(
                    <string>localStorage.getItem("auth_user_crocs")
                );
                if (data && data.addProductToCompare) {
                    this.addToCompareList(data.addProductToCompare);
                } else if (data && data.removeProductFromCompare) {
                    this.openConfirmationPopup(data.removeProductFromCompare);
                } else if (data && data.cloneCompareLocalData) {
                    /*this.cloneLocalData();*/
                } else if (data && data.loggedInUser) {
                } else if (data && data.loggedOutUser) {
                }
            }
        );
    }

    ngOnInit() {
        this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(
            navigator.userAgent
        );
        this.isAuthUser = JSON.parse(
            <string>localStorage.getItem("auth_user_crocs")
        );
        this.embryoService.compareListSub.subscribe((res) => {
            this.compareListProducts = res;
            this.compareListProducts.forEach((product: any) => {
                product.slug_name = this.getProductName(product);
            });
        });
        this.confgServ.getenvConfig().subscribe((res) => {
            this.environmentVariables = res;
           this.headerIconsColor =   this.environmentVariables.HEADER_ICONS_FILL_COLOR;

        });
    }

    ngAfterViewInit() {
        setTimeout(() => {
            this.embryoService.productCartSub.subscribe((res) => {
                if (res) {
                    this.compareListProducts.forEach((element) => {
                        let indexProduct;
                        if (res.items) {
                            indexProduct = res.items.findIndex(
                                (item: any) => item.id == element.id
                            );
                        } else {
                            indexProduct = res.findIndex(
                                (item: any) => item.id == element.id
                            );
                        }
                        if (indexProduct !== -1) {
                            element.amount = res[indexProduct].amount;
                        } else {
                            element.amount = 0;
                        }
                    });
                }
            });
        }, 10);
    }

    ngOnDestroy() {
        if (this.subscription) this.subscription.unsubscribe();
    }

    checkUserGuest() {
        this.router.navigate(["/" + this.lang + "/compare"]);
    }

    openConfirmationPopup(product: any) {
        this.unCompare(product);
    }

    addToCompareList(product: any) {
        if (this.isAuthUser) {
            this.homePageService
                .addToCompareList(product.id)
                .subscribe((res: any) => {
                    if (res.code === 200) {
                        this.checkProduct(product);
                        this.addMsg();
                    } else {
                        Swal.fire({
                            html: `<p style='color:white'>${res.message}</p>`,
                            width: 250,
                            position: "bottom-end",
                            background: "#bd362f",
                            timerProgressBar: true,
                            showConfirmButton: false,
                            timer: 3000,
                            backdrop: false,
                            allowOutsideClick: true,
                        });
                    }
                    this.embryoService.compareListSub.next(
                        this.compareListProducts
                    );
                });
        } else {
            this.embryoService.addToCompare(product);
        }
    }

    unCompare(product: any) {
        product["loading"] = true;
        if (this.isAuthUser) {
            this.homePageService
                .removeFromCompareList(product.id)
                .subscribe((res: any) => {
                    product["loading"] = false;
                    if (res.code === 200) {
                        this.removeProduct(product);
                        this.removeMsg();
                    } else {
                        Swal.fire({
                            html: `<p style='color:white'>${res.message}</p>`,
                            width: 250,
                            position: "bottom-end",
                            background: "#bd362f",
                            timerProgressBar: true,
                            showConfirmButton: false,
                            timer: 3000,
                            backdrop: false,
                            allowOutsideClick: true,
                        });
                    }
                    this.embryoService.compareListSub.next(
                        this.compareListProducts
                    );
                });
        } else {
            setTimeout(() => {
                product["loading"] = false;
                this.embryoService.removeProductFromCompareGuest(product);
            }, 200);
        }
    }

    checkProduct(product: any) {
        const clonedProduct = { ...product };
        const productsIdx = this.compareListProducts.findIndex(
            (item) => item.id === clonedProduct.id
        );
        if (productsIdx == -1) {
            clonedProduct.amount = null;
            this.compareListProducts.push(clonedProduct);
        }
    }

    removeProduct(product: any) {
        if (product) {
            const index = this.compareListProducts.findIndex(
                (item) => item.id === product.id
            );
            if (index != -1) {
                this.compareListProducts.splice(index, 1);
            }
        }
    }
    getProductName(product: any) {
        // const nameRouting = product.name_en
        //     .replace(/[^\w\s]/gi, "-")
        //     .replace(/ /g, "-");
        // const parentId = product.parent_id || product.id;
        // return nameRouting + "/" + parentId;
				return this.slugNameService.getProductName(product);
    }

    addMsg() {
        const toastOption = {
            title: "Compare",
            msg: "",
        };
        if (this.lang === "en") {
            toastOption.title = "Compare";
            toastOption.msg = "Product added to compare successfully";
        } else {
            toastOption.title = "المقارنة";
            toastOption.msg = "تم إضافة المنتج الي المقارنة بنجاح";
        }

        Swal.fire({
            html: `<p style='color:white'>${toastOption.msg}</p>`,
            width: 250,
            position: "bottom-end",
            background: "#51A351",
            timerProgressBar: true,
            showConfirmButton: false,
            timer: 3000,
            backdrop: false,
            allowOutsideClick: true,
        });
    }

    removeMsg() {
        const toastOption = {
            title: "Compare",
            msg: "",
        };
        if (this.lang === "en") {
            toastOption.title = "Compare";
            toastOption.msg = "Product removed from compare successfully";
        } else {
            toastOption.title = "المقارنة";
            toastOption.msg = "تم إزالة المنتج من المقارنة بنجاح";
        }
        Swal.fire({
            html: `<p style='color:white'>${toastOption.msg}</p>`,
            width: 250,
            position: "bottom-end",
            background: "#51A351",
            timerProgressBar: true,
            showConfirmButton: false,
            timer: 3000,
            backdrop: false,
            allowOutsideClick: true,
        });
    }

    toggleMenu(event: any, open: any) {
        if (!this.isMobile) {
            if (open) {
                event.stopPropagation();
                this.enteredMenu = false;
                this.menuTrigger.openMenu();
            } else {
                setTimeout(() => {
                    if (!this.enteredMenu) {
                        this.menuTrigger.closeMenu();
                    }
                }, 150);
            }
        }
    }

    closeMatMenu() {
        this.enteredMenu = false;
        this.menuTrigger.closeMenu();
    }
}
